import { SuccessSVG } from "assets";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
import React from "react";
import { Button, DatePicker, Form, Input, Select, Space, Tooltip } from "antd";
import moment from "moment";
import dayjs from "dayjs";

const { INPUT, SELECT, DATE, AUTO_COMPLETE, COMBO_BOX, BUTTON } = FIELD_TYPE;

const fields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "id",
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "description",
  },
  {
    type: INPUT,
    label: "Giới tính",
    name: "description",
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "roleName",
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "description",
  },
  {
    type: DATE,
    label: "Thời gian khám",
    name: "roleName",
  },
  {
    type: SELECT,
    label: "Khu khám",
    name: "roleName",
  },
  {
    type: SELECT,
    label: "Loại hình khám",
    name: "roleName",
  },
  {
    type: AUTO_COMPLETE,
    label: "Người thực hiện",
    name: "roleName",
  },
];

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "STT",
    dataIndex: "stt",
    width: 40,
    fixed: "left",
    align: "center",
  },
  {
    title: "Chỉ định",
    key: "chiDinh",
    dataIndex: "chiDinh",
    width: 300,
  },
  {
    title: "Bác sĩ chỉ định",
    key: "bacSyChiDinh",
    dataIndex: "bacSyChiDinh",
    width: 150,
  },
  {
    title: "Máy CĐHA",
    key: "mayXetNghiem",
    dataIndex: "mayXetNghiem",
    width: 250,
    type: COMBO_BOX,
  },
  {
    title: "Thời gian bắt đầu",
    key: "thoiGianBatDau",
    dataIndex: "thoiGianBatDau",
    width: 150,
    align: "center",
    type: DATE,
  },
  {
    title: "Thời gian cộng thêm",
    key: "",
    dataIndex: "thoiGianCongThem",
    width: 200,
    type: BUTTON,
    align: "center",
  },
  {
    title: "Thời gian kết thúc",
    key: "thoiGianKetThuc",
    dataIndex: "thoiGianKetThuc",
    width: 150,
    type: DATE,
  },
  {
    title: "TT",
    key: "trangThai",
    dataIndex: "trangThai",
    align: "center",
    width: 50,
    render: (text) => {
      if (text == 0)
        return (
          <Tooltip title="">
            <SuccessSVG className="success-red" />
          </Tooltip>
        );
      if (text == 1) return <SuccessSVG className="success-green" />;
      if (text == 2) return <SuccessSVG className="success-gray" />;
      if (text == 3) return <SuccessSVG className="success-green" />;
      if (text == 4) return <SuccessSVG className="success-greeness" />;
    },
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    dataIndex: "ghiChu",
    width: 300,
    type: INPUT,
  },
  {
    title: "Thao tác",
    key: "actions",
    dataIndex: "actions",
    width: 200,
    fixed: "right",
  },
];

export { fields, allColumns };
